<div class="min-h-screen bg-blueGray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <div class="text-center mb-6">
      <img class="h-10 mx-auto" src="assets/brand/atc_full_blueOnTransparent.png" alt="AtChurch" />
    </div>

    <div class="bg-white py-8 px-6 shadow-xl rounded-3xl sm:px-10 border border-blueGray-200/80">
      @if (loading) {
        <div class="py-12 text-center text-blueGray-400 text-xs">
          <i class="fas fa-spinner fa-spin text-2xl text-primary-500 mb-3 block"></i>
          Loading management group details...
        </div>
      } @else if (!organization) {
        <div class="text-center py-8">
          <div class="h-14 w-14 rounded-2xl bg-rose-50 text-rose-500 flex items-center justify-center text-2xl mx-auto mb-3">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <h2 class="text-lg font-bold text-blueGray-800">Management Group Not Found</h2>
          <p class="text-xs text-blueGray-500 mt-2">
            The invitation link might be expired or invalid. Please request a new invite link from your network administrator.
          </p>
          <a
            [routerLink]="['/groups']"
            class="mt-5 inline-block px-4 py-2 rounded-xl bg-primary-500 text-white text-xs font-semibold shadow-xs">
            Go to Home
          </a>
        </div>
      } @else {
        <!-- Organization Preview -->
        <div class="text-center">
          @if (organization.logoUrl) {
            <img
              [src]="organization.logoUrl"
              [alt]="organization.name"
              class="h-20 w-20 rounded-2xl object-cover border border-blueGray-200 shadow-sm mx-auto mb-4" />
          } @else {
            <div class="h-20 w-20 rounded-2xl bg-gradient-to-tr from-primary-500 to-indigo-600 text-white font-extrabold text-2xl flex items-center justify-center mx-auto mb-4 shadow-md">
              <i class="fas fa-sitemap"></i>
            </div>
          }

          <span class="px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase bg-primary-50 text-primary-600 border border-primary-100 inline-block mb-2">
            Management Network Invitation
          </span>

          <h2 class="text-xl font-extrabold text-blueGray-900 tracking-tight">
            {{ organization.name }}
          </h2>

          <p class="text-xs text-blueGray-500 mt-2 leading-relaxed">
            {{ organization.description || 'You have been invited to connect with this management and governance network.' }}
          </p>

          @if (organization.contactEmail) {
            <div class="mt-4 pt-3 border-t border-blueGray-100 text-[11px] text-blueGray-400 flex items-center justify-center gap-1.5">
              <i class="fas fa-envelope text-primary-500"></i>
              <span>{{ organization.contactEmail }}</span>
            </div>
          }

          <!-- Action Button -->
          <div class="mt-6">
            @if (isActiveMember) {
              <a
                [routerLink]="['/management', orgId]"
                class="w-full py-3 px-4 rounded-xl bg-primary-500 hover:bg-primary-600 text-white text-xs font-bold shadow-md hover:shadow-lg transition-all flex items-center justify-center gap-2 cursor-pointer">
                <i class="fas fa-sitemap text-xs"></i>
                <span>Open Organizational Chart</span>
              </a>
            } @else if (hasPendingRequest) {
              <button
                type="button"
                disabled
                class="w-full py-3 px-4 rounded-xl bg-amber-50 text-amber-700 border border-amber-200 text-xs font-bold flex items-center justify-center gap-2 cursor-not-allowed">
                <i class="fas fa-hourglass-half text-xs"></i>
                <span>Request Pending Review</span>
              </button>
            } @else {
              <button
                type="button"
                [disabled]="actionInProgress$ | async"
                (click)="onRequestJoin()"
                class="w-full py-3 px-4 rounded-xl bg-primary-500 hover:bg-primary-600 text-white text-xs font-bold shadow-md hover:shadow-lg transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-50">
                @if (actionInProgress$ | async) {
                  <i class="fas fa-spinner fa-spin text-xs"></i>
                  <span>Submitting...</span>
                } @else if (!isLoggedIn) {
                  <i class="fas fa-paper-plane text-xs"></i>
                  <span>Login to Join Group</span>
                } @else if (hasPendingInvite) {
                  <i class="fas fa-check text-xs"></i>
                  <span>Accept Invitation</span>
                } @else {
                  <i class="fas fa-paper-plane text-xs"></i>
                  <span>Request to Join Group</span>
                }
              </button>
            }
          </div>

          <p class="text-[10px] text-blueGray-400 mt-3">
            @if (isActiveMember) {
              You are already a member of this management network.
            } @else if (hasPendingRequest) {
              An administrator of this management network will review your request.
            } @else if (hasPendingInvite) {
              You have been invited. Accepting makes you a member straight away.
            } @else {
              An administrator of this management network will review your request.
            }
          </p>
        </div>
      }
    </div>
  </div>
</div>
